<div>
  <button
    id="close-btn"
    class="!tw-absolute tw-top-2 tw-right-2 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="tw-text-white">close</mat-icon>
  </button>

  <div
    mat-dialog-title
    class="matp-bg-warn !tw-flex tw-items-center !tw-pt-2 !tw-text-white"
  >
    <mat-icon class="tw-text-[3rem] !tw-h-12 !tw-w-12 tw-mr-4 matp-fill-icon">
      cancel
    </mat-icon>
    <span class="tw-text-[2rem]">{{ title }}</span>
  </div>

  <mat-dialog-content
    class="!tw-flex tw-flex-col tw-gap-8 tw-w-full tw-whitespace-pre-wrap !tw-text-xl !tw-p-8 !tw-pb-12"
  >
    <span>{{ message }}</span>

    <div class="matp-table-area">
      <table
        mat-table
        [dataSource]="dataSource"
        id="device-group-bulk-setting-error-table"
        class="matp-table"
      >
        <ng-container matColumnDef="deviceId">
          <th mat-header-cell *matHeaderCellDef>
            <div class="matp-table-header-title">デバイスID</div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.deviceId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="errorMessage">
          <th mat-header-cell *matHeaderCellDef>
            <div class="matp-table-header-title">エラー情報</div>
          </th>
          <td mat-cell *matCellDef="let element" class="tw-whitespace-pre-wrap">
            {{ element.errorMessage }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="!tw-pb-5">
    <button
      mat-raised-button
      mat-dialog-close
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
    >
      <mat-icon>close</mat-icon>
      閉じる
    </button>
  </mat-dialog-actions>
</div>
